define('WidgetCollectionView',['jquery', 'backbone', 'app', 'SubView', 'WidgetInstanceView', 'UrlFactory'],
    function ($, backbone, app, SubView, WidgetInstanceView, UrlFactory) {

        //
        // représente l'abstraction d’une View d'une collection de Widgets
        //

        return backbone.View.extend(SubView).extend({
            className: 'widget-collection',
            events: {},
            initialize: function (groupIdentifiant, options) {
                //

                if ($('html').hasClass('no-js'))
                        return ;
                var view = this;

                function setDefault(key,defaultValue){
                    if (typeof options != 'undefined' &&  typeof options[key] != 'undefined') {
                        view[key] = options[key];
                    }else{
                        view[key] = defaultValue;
                    }
                }


                view.subviews = [];
                view.options = options;
                view.groupIdentifiant = groupIdentifiant;
                setDefault('type','normal');

                var group = app.getWidgetGroup(groupIdentifiant);

                view.use_container = false;
                if (view.type == "page" && group.get('use_container') == true)
                {
                    view.use_container = true;
                }

                view.updateCollection();
                view.listenTo(app.getCustomer(), 'login logout', view.updateCollection);
            },
            updateCollection: function () {
                var view = this,
                    identifiant = view.groupIdentifiant;
                try {
                  var  collection = app.getWidgetCollectionFromGroup(identifiant);
                    if (!view.collection || collection.cid !== view.collection.cid) {
                        view.collection = collection;
                        if (collection) {
                            collection.prepareDatas(function(){
                                view.render()
                            });
                        }
                    }
                } catch (err) {
                    app.error('WidgetCollectionViewError',{widgetgroup:identifiant});
                    app.blockError(view.$el);
                    // view.groupIdentifiant
                }
            },
            render: function () {

                var view = this,
                    collection = view.collection;

                view.$el.addClass('collection-' + collection.id);
                view.$el.empty();
                var layoutContainer = view.$el;

                if (view.use_container)
                {
                    layoutContainer = $('<div class="container collection-container"></div>');
                    view.$el.append(layoutContainer);
                }
                collection.getLayouts().each(function (layout) {
                    // var id_picture = layout.get('picture'), inlineStyle = '';
                    // if(id_picture){
                    //     var pictureUrl = UrlFactory.getUrlPicture(id_picture,'widgetlayout','origin','layout','jpg');
                    //     inlineStyle = " style='background-image:url(\'"+pictureUrl+"\')'";
                    // }
                    var layoutEl = $('<div class="widget-layout format-' + layout.get('name_format') + ' '+ layout.get('class_desktop') + '"></div>');
                    layoutContainer.append(layoutEl);
                    layout.getInstances().each(function (instance) {
                        try {
                            if (app.isMobile() && instance.get('params').viewonmobilehide == '1') {
                                return;
                            }
                            instance = instance.clone();
                            instance.set('collection',collection);
                            instance.set('options', view.options);
                            //
                            var viewClass = WidgetInstanceView.factoryWidgetView(instance), widgetInstanceView = new viewClass(instance);
                            view.attachView(widgetInstanceView);
                            layoutEl.append(widgetInstanceView.$el);
                            widgetInstanceView.render();
                        }catch(err){
                            var block = $('<div class="widget-instance"></div>');
                            app.error('WidgetCollectionView'+err.toString(),{id:collection.id});
                            layoutEl.append(block);
                            app.blockError(block);
                        }
                    });
                });

            }
        });
    });
